// Generated by CoffeeScript 2.7.0
Vue.directive('animationend', {
  bind: function(el, binding, vnode, oldVnode) {
    var fn;
    fn = function(event) {
      if (binding.modifiers.stop) {
        event.stopPropagation();
      }
      if (binding.modifiers.prevent) {
        event.preventDefault();
      }
      if (_.isFunction(binding.value)) {
        return binding.value(event);
      }
    };
    el.addEventListener('webkitAnimationEnd', fn, false);
    el.addEventListener('MSAnimationEnd', fn, false);
    el.addEventListener('oanimationend', fn, false);
    return el.addEventListener('animationend', fn, false);
  }
});
